import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { TaggableCreatorsItem } from '@/dialogs/TagOtherCreatorsAndReleaseFormsDialog/TagUserTabContent/TaggableCreatorsItem.tsx'
import type { Message } from '@/modules/chatting/types.ts'
import { isGuestType, isUserType } from '@/utils/releaseForms'

import { ReleaseFormItem } from '../TagOtherCreatorsAndReleaseFormsDialog/ReleaseFormTabContent/ReleaseFormItem'
import type { DialogProps } from '../types'
import { useManageTags } from './useManageTags'

interface ShowOtherCreatorsDialogProps extends DialogProps {
  message: Message
}

export const ShowOtherCreatorsDialog: React.FC<
  ShowOtherCreatorsDialogProps
> = ({ isOpen, onClose, message }) => {
  const { onRemove, isRemoving, handleEditTag, tags } = useManageTags({
    message,
    onRemoveLastTag: onClose,
  })

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      panelClassName="w-[400px]"
    >
      <Dialog.Header>
        <Dialog.Title>Tags</Dialog.Title>
      </Dialog.Header>
      <div className="border-border-secondary bg-card relative mt-6 max-h-[532px] w-full flex-1 overflow-scroll rounded-lg border py-4">
        {tags?.map((tag) =>
          isUserType(tag.type) || isGuestType(tag.type) ? (
            <TaggableCreatorsItem
              key={tag.id}
              taggable={tag}
              onRemoveTag={() => onRemove(tag.id)}
              onEditTag={handleEditTag}
            />
          ) : (
            <ReleaseFormItem
              releaseForm={tag}
              onRemoveTag={() => onRemove(tag.id)}
              key={tag.id}
            />
          ),
        )}
      </div>

      <Dialog.Footer>
        <Button
          type="button"
          onClick={onClose}
          className="flex-1"
          variant="outline"
          isLoading={isRemoving}
        >
          Cancel
        </Button>
      </Dialog.Footer>
    </Dialog>
  )
}
